import { RequestStatus } from '../../../enums/requestStatus';
import { EntitlementsResponse } from '../../../models/entitlements';

export const ENTITLEMENTS_REDUCER_NAME = 'entitlements';

export interface EntitlementsReducer {
  data: EntitlementsResponse | null;
  status: RequestStatus | null;
  error: string | null;
}
